import { createStandaloneToast } from '@chakra-ui/react';

import { theme } from './theme';

export const { ToastContainer: StandaloneToastContainer, toast } = createStandaloneToast({ theme });
